/**
 *
 * SlackWizard
 *
 */

import React from 'react';

import { CreateSlack } from 'containers/Setup/Integrations/Components/IntegrationsWizard/Slack/Components/CreateSlack';
import { EditSlack } from 'containers/Setup/Integrations/Components/IntegrationsWizard/Slack/Components/EditSlack';
import { useIntegrationsContext } from 'containers/Setup/Integrations/context/context';

export const SlackWizard = () => {
  const { actionType } = useIntegrationsContext();

  return actionType === 'Add' ? <CreateSlack /> : <EditSlack />;
};
